import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { hasValue, code2region } from './Utils'

export class DataService {
	
	constructor(tfRef) {
		
		const [loaded, setLoaded] = useState(moment())
		const [events, setEvents] = useState([])
		const [fires, setFires] = useState([])
		const [fireRegCl, setFireRegCl] = useState([])
		const [weather, setWeather] = useState([])
		const [weatherThresh, setWeatherThresh] = useState(3)
		const [showFire, setShowFire] = useState(false)
		const [showFireActuality, setShowFireActuality] = useState(true)
		const [showWeatherArchive, setShowWeatherArchive] = useState(false)
		const [weatherArchive, setWeatherArchive] = useState([])
		const [quakes, setQuakes] = useState([])
		const [fQuakes, setFQuakes] = useState([])
		const [showQuakes, setShowQuakes] = useState(false)
		const [showAllQuakes, setShowAllQuakes] = useState(false)
		const [activeEvents, setActiveEvents] = useState([])
		const [shutoffs, setShutoffs] = useState([])
		const [shutoff_tso, setShutoff_tso] = useState([])
		const [orgs, setOrgs] = useState([])
		const [def_org, setDef_org] = useState([])
		const [prevMass, setPrevMass] = useState([])
		const [fEvents, setFEvents] = useState([])
		const [filters, setFilters] = useState({
			showMap: true,
		})
		const [objCache, setObjCache] = useState({'NULL': false})
		const [specobjects, setSpecobjects] = useState([])
		const [milobjects, setMilobjects] = useState([])
		const [titles, setTitles] = useState([])
		const [svgFiles, setSvgFiles] = useState({})
		const [showDeenergized, setShowDeenergized] = useState(this.loadFromStorage('showDeenergized', false))
		const [showFireRegCl, setShowFireRegCl] = useState(this.loadFromStorage('showFireRegCl', false))
		const [deenergized, setDeenergized] = useState([])
		const [deenergized_sum, setDeenergized_sum] = useState(0)
		const [panels, setPanels] = useState([])
		const [durations, setDurations] = useState([])
		const [visiblePoweroff, setVisiblePoweroff] = useState([])
		const [poweroff, setPoweroff] = useState({})
		const [tso, setTso] = useState([])
		const [hiddenAlerts, setHiddenAlerts] = useState(this.loadFromStorage('hiddenAlerts', []))
		const [alertThreshHi, setAlertThreshHi] = useState(this.loadFromStorage('alertThreshHi', 5000))
		const [alertThreshLo, setAlertThreshLo] = useState(this.loadFromStorage('alertThreshLo', 1000))
		const [massGraphField, setMassGraphField] = useState(this.loadFromStorage('massGraphField', 'ep'))
		const [fireMomentBounds, setFireMomentBounds] = useState([moment('2000-01-01 00:00'), moment('2000-01-01 00:00')])
		const [weatherMomentBounds, setWeatherMomentBounds] = useState([moment('2000-01-01 00:00'), moment('2000-01-01 00:00')])
		const maxQuakeMomentOffset = 24 * 7
		const weatherForecastPeriodOptions = ['0-12', '12-24', '24-36']
		const [weatherForecastPeriod, setWeatherForecastPeriod] = useState(weatherForecastPeriodOptions[0])
		const [showWeatherWarnings, setShowWeatherWarnings] = useState(false)
		const [showWeatherDangers, setShowWeatherDangers] = useState(false)
		const [weatherFilterOptions, setWeatherFilterOptions] = useState([])
		const [showMeteoDetails, setShowMeteoDetails] = useState(false)
		const [showIcingZones, setShowIcingZones] = useState(false)
		const [showWindZones, setShowWindZones] = useState(false)
		const [showColdTempZones, setShowColdTempZones] = useState(false)
		const [showHotTempZones, setShowHotTempZones] = useState(false)
		const [icingHum, setIcingHum] = useState(85)
		const [icingWind, setIcingWind] = useState(5)
		const [icingTemp, setIcingTemp] = useState([-2, 1])
		const [windWind, setWindWind] = useState(10)
		const [coldTemp, setColdTemp] = useState(-35)
		const [hotTemp, setHotTemp] = useState(32)

		
		const weather_warn_names = {
			'из-за сильного ветра': 'Ветер',
			'из-за дождей': 'Дождь',
			'из-за грозы': 'Гроза',
			'из-за обледенения': 'Обледенение',
			'из-за жары': 'Жара',
		}

		const [app, setApp] = useState(this.loadFromStorage('app'))
		const mapOptions = (app?.User?.map_options ? app.User.map_options.split(',') : []).reduce((a, e) => {a[e] = true; return a}, {})
		const [showMapSettings, setShowMapSettings] = useState(false)
		const [showObjectViewerSettings, setShowObjectViewerSettings] = useState(false)
		const [useCustomViewport, setUseCustomViewport] = useState(this.loadFromStorage('useCustomViewport', false))
		const [customViewportWidth, setCustomViewportWidth] = useState(this.loadFromStorage('customViewportWidth', 4000))
		const [customViewportHeight, setCustomViewportHeight] = useState(this.loadFromStorage('customViewportHeight', 4000))
		const [customLineScale, setCustomLineScale] = useState(this.loadFromStorage('customLineScale', 4))
		const [customMarkerScale, setCustomMarkerScale] = useState(this.loadFromStorage('customMarkerScale', 2))
		const [regionBorders, setRegionBorders] = useState([])
		const [geoObjects, setGeoObjects] = useState([])
		
		const userSettings = { visiblePoweroff, app, mapOptions, showMapSettings, showObjectViewerSettings }
		const data =    {    loaded,    events,    fires,    showFire,    showFireActuality,    activeEvents,    shutoffs,    fEvents,    objCache,    titles,    deenergized,    deenergized_sum,    panels,    durations,    poweroff,    tso,
											   showDeenergized,    showQuakes,    showAllQuakes,    quakes,    fQuakes,    weatherForecastPeriod,    showWeatherWarnings,    showWeatherDangers,    weather,    weatherThresh,    weatherFilterOptions, 
											   showWeatherArchive,    weatherArchive,    showMeteoDetails,    showIcingZones,    showWindZones,    showColdTempZones,    showHotTempZones,
											   icingHum,    icingWind,    icingTemp,    windWind,    coldTemp,    hotTemp,
											   fireRegCl,    showFireRegCl,
											   shutoff_tso,    orgs,    def_org,    specobjects,    milobjects, 
												 hiddenAlerts,    alertThreshHi,    alertThreshLo,    massGraphField,    prevMass,    fireMomentBounds,    weatherMomentBounds,
												 useCustomViewport,    customViewportWidth,    customViewportHeight,    customLineScale,    customMarkerScale, 
												 regionBorders,    geoObjects,    
												 svgFiles, maxQuakeMomentOffset, weatherForecastPeriodOptions, weather_warn_names
										}
		const setters = { setLoaded, setEvents, setFires, setShowFire, setShowFireActuality, setActiveEvents, setShutoffs, setFEvents, setObjCache, setTitles, setDeenergized, setDeenergized_sum, setPanels, setDurations, setPoweroff, setTso, 
											setShowDeenergized, setShowQuakes, setShowAllQuakes, setQuakes, setFQuakes, setWeatherForecastPeriod, setShowWeatherWarnings, setShowWeatherDangers, setWeather, setWeatherThresh, setWeatherFilterOptions, 
											setShowWeatherArchive, setWeatherArchive, setShowMeteoDetails, setShowIcingZones, setShowWindZones, setShowColdTempZones, setShowHotTempZones,
											setIcingHum, setIcingWind, setIcingTemp, setWindWind, setColdTemp, setHotTemp,
											setFireRegCl, setShowFireRegCl, 
											setShutoff_tso, setOrgs, setDef_org, setSpecobjects, setMilobjects, 
											setHiddenAlerts, setAlertThreshHi, setAlertThreshLo, setMassGraphField, setPrevMass, setFireMomentBounds, setWeatherMomentBounds,
											setUseCustomViewport, setCustomViewportWidth, setCustomViewportHeight, setCustomLineScale, setCustomMarkerScale, 
											setRegionBorders, setGeoObjects, 
											setFilters, setVisiblePoweroff, setShowMapSettings, setShowObjectViewerSettings
										}
		
		this.data = data
		this.filters = filters
		this.setters = setters
		this.userSettings = userSettings
		this.topFiltersRef = tfRef
		
		useEffect(() => {
			if (titles.length) {
				this.topFiltersRef?.current?.reloadData()
			}
		}, [weatherForecastPeriod])
		
		useEffect(() => {this.saveToStorage('hiddenAlerts', hiddenAlerts)}, [hiddenAlerts])
		useEffect(() => {this.saveToStorage('alertThreshHi', alertThreshHi)}, [alertThreshHi])
		useEffect(() => {this.saveToStorage('alertThreshLo', alertThreshLo)}, [alertThreshLo])
		useEffect(() => {this.saveToStorage('massGraphField', massGraphField)}, [massGraphField])
		useEffect(() => {this.saveToStorage('showDeenergized', showDeenergized)}, [showDeenergized])
		useEffect(() => {this.saveToStorage('showFireRegCl', showFireRegCl)}, [showFireRegCl])
		useEffect(() => {this.saveToStorage('useCustomViewport', useCustomViewport)}, [useCustomViewport])
		useEffect(() => {this.saveToStorage('customViewportWidth', customViewportWidth)}, [customViewportWidth])
		useEffect(() => {this.saveToStorage('customViewportHeight', customViewportHeight)}, [customViewportHeight])
		useEffect(() => {this.saveToStorage('customLineScale', customLineScale)}, [customLineScale])
		useEffect(() => {this.saveToStorage('customMarkerScale', customMarkerScale)}, [customMarkerScale])
		
	}
	
	loadFromStorage(key, defaultValue = {}) {
		const val = localStorage.getItem(key)
		return val ? JSON.parse(val) : defaultValue
	}
	
	saveToStorage(key, value) {
		localStorage.setItem(key, JSON.stringify(value))
	}
	
	compare(d1, d2) {
		return d1.population === d2.population && d1.region_code === d2.region_code && d1.company === d2.company && d1.head_company === d2.head_company && d1.filialName === d2.filialName
	}
	
	loadObjects(newUuids, data1 = null) {
		if (newUuids.size) {
			const formData = new FormData()
			//console.log('requested objects:', newUuids.length)
			newUuids.forEach(e => formData.append('uuids[]', `${e}`))
			fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/objinfo/', {
				method: 'POST',
				body: formData
			}).then(res => res.json()).then(data2 => {
				if (data2.success && data2.objects) {
					data2.objects.forEach(e => {
						e.uuid =  e.uuid.toUpperCase()
						e.type = Number(e.type)
						if (e.geospa?.startsWith('LINESTRING (')) {
							e.line = e.geospa.substr('LINESTRING ('.length, e.geospa.length-'LINESTRING ('.length-1).split(',').map(ep => ep.trim().split(' ').map(ec => parseFloat(ec))).map(([a, b]) => [b, a])
						} else if (e.geospa?.startsWith('MULTILINESTRING (')) {
							e.line = e.geospa.substr('MULTILINESTRING (('.length, e.geospa.length-'MULTILINESTRING (('.length-2).split('), (').map(s => s.split(',').map(ep => ep.trim().split(' ').map(ec => parseFloat(ec))).map(([a, b]) => [b, a]))
						} else if (e.geospa?.startsWith('GEOMETRYCOLLECTION (')) {
							e.line = e.geospa.substr('GEOMETRYCOLLECTION (LINESTRING ('.length, e.geospa.length-'GEOMETRYCOLLECTION (LINESTRING ('.length-2).split('), LINESTRING (').map(s => s.split(',').map(ep => ep.trim().split(' ').map(ec => parseFloat(ec))).map(([a, b]) => [b, a]))
						}
						// is it a line object?
						if ([3].includes(e.type)) {
							e.regs = e.regs ? e.regs.split(',').map(r => Number(r)) : []
							if (e.middle) e.latlng = e.middle.substr('POINT ('.length, e.middle.length-'POINT ('.length-1).split(' ').map(ec => parseFloat(ec)).reverse()
							else if (e.late && e.lone && e.lats && e.lons) e.latlng = [(Number(e.late) + Number(e.lats)) / 2, (Number(e.lone) + Number(e.lons)) / 2]
							else if (e.late && e.lone || e.lats && e.lons) e.latlng = [(Number(e.late ? e.late : e.lats) + Number(e.lats ? e.lats : e.late)) / 2, (Number(e.lone ? e.lone : e.lons) + Number(e.lons ? e.lons : e.lone)) / 2]
							if (e.regs.length > 0) {
								e.reg = e.regs[0]
							} else if (data1) {
								e.reg = Number(data1.Result.eventsZh.find(a => a.object_uuids.some(u => u === e.uuid)).regionId.split(',')[0])
							}
						} else {
							if (e.reg) e.reg = Number(e.reg)
							if (e.lat && e.lon) e.latlng = [Number(e.lat), Number(e.lon)]
						}
						this.data.objCache[e.uuid] = e
					})
					//console.log('cached objects', Object.keys(this.data.objCache).length)
					newUuids.forEach(ne => {
						if (!data2.objects.map(el => el.uuid).includes(ne)) this.data.objCache[ne] = false
					})
					this.setters.setObjCache({...this.data.objCache})
				}
			})
		}
	}
	
	loadGeoObjects(uuids) {
		const _uuids = uuids.split('\n').map(e => e.toUpperCase())
		const newUuids = new Set()
		_uuids.filter(s => !Object.keys(this.data.objCache).includes(s)).forEach(uuid => newUuids.add(uuid))
		//console.log(_uuids, newUuids, this.data.objCache)
		this.loadObjects(newUuids)
		this.setters.setGeoObjects(_uuids)
	}
	
	loadEvents(dates, period, unrestrictedMode, unresolvedMode, specobjects = false) {
		const formData = new FormData()
		if (!period || period === 'Оперативный') {
			formData.append('period', 'operational')
		} else {
			formData.append('period', 'setperiod')
		}
		formData.append('startDate', moment(dates[0]).format('YYYY-MM-DD'))
		formData.append('endDate', ( dates[1] ? moment(dates[1]) : moment() ).add(1, 'd').format('YYYY-MM-DD'))
		formData.append('unrestrictedMode', unrestrictedMode)
		formData.append('unresolvedMode', unresolvedMode)
		formData.append('weather_period', this.data.weatherForecastPeriod)
		if (specobjects) formData.append('specobjects', this.userSettings?.mapOptions?.specobjects)
		fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/ajax/events/', {
			method: 'POST',
			body: formData
		}).then(res => res.json()).then(data1 => {
			if (data1.Error && data1.Error.Code === 0) {
				if (this.data.titles.length === 0) this.setters.setTitles(data1.Result.titles)
				const _deenergized = data1.Result.deenergized.sort((a, b) => b.population - a.population)
				if (this.data.deenergized.length !== _deenergized.length) {
					this.setters.setDeenergized(_deenergized)
				} else {
					for (let i = 0; i < _deenergized.length; i++) {
						if (!this.compare(_deenergized[i], this.data.deenergized[i])) {
							this.setters.setDeenergized(_deenergized)
							//console.log('setDeenergized', this.data.deenergized, _deenergized)
							break
						}
					}
				}
				this.setters.setDeenergized_sum(data1.Result.deenergized_sum)
				this.setters.setPanels(data1.Result.panels)
				this.setters.setDurations(data1.Result.dur)
				this.setters.setTso(data1.Result.tso)
				//this.setters.setWeather(data1.Result.weather.filter(e => e.w === 'break' || e.p > data1.Result.weather.thresh))
				this.setters.setWeather(
					Object.entries(data1.Result.weather)
						.filter(([k, v]) => k !== 'thresh')
						//.filter(([k, v]) => v.w === 'break' || v.p >= data1.Result.weather.thresh)
						.map(([k, v]) => [code2region[k].oktmo, v])
				)
				this.setters.setWeatherThresh(data1.Result.weather.thresh)
				this.setters.setSpecobjects(data1.Result.so)
				this.setters.setMilobjects(data1.Result.mo.map(e => {
					let _lat = e.lat
					let _lng = e.lng
					return {
						name: e.name,
						lat: _lat,
						lng: _lng,
						ka_event_date: e.ka_event_date.replace('{', '').replace('}', '').split(',').map(el => moment(el.replaceAll('"', ''))).sort((a, b) => b - a)
					}
				}).sort((a, b) => a.ka_event_date.length - b.ka_event_date.length))
				
				const newUuids = new Set()
				data1.Result.eventsZh.forEach(e => {
					e.ds = moment(e.startincident)
					e.de = e.resolvedata === '0001-01-01 00:00:00' ? null : moment(e.resolvedata)
					if (e.ka_power_supply_rest_date) e.rd = e.ka_power_supply_rest_date === '0001-01-01 00:00' ? null : moment(e.ka_power_supply_rest_date)
					e.object_uuids = e.ka_object_uuid.substring(1, e.ka_object_uuid.length-1).split(',').filter(s => s !== 'NULL').map(s => s.toUpperCase())
					e.object_uuids.filter(s => !Object.keys(this.data.objCache).includes(s))
						.forEach(uuid => newUuids.add(uuid))
					const {uuid, disabled_consumers, disabled_endpoints, cut_off_power, cut_off_power_consumers, cut_off_power_industrial, number_attracted_avr, ka_involved_personnel, ka_involved_special_units} = data1.Result.shutoffs.find(s => s.uuid === e.id)
					if (e.cut_off_power_consumers || e.cut_off_power_industrial) e.cut_off_power = (e.cut_off_power_consumers ? Number(e.cut_off_power_consumers) : 0) + (e.cut_off_power_industrial ? Number(e.cut_off_power_industrial) : 0)
					Object.assign(e, {
						max_disabled_consumers: disabled_consumers, 
						max_disabled_endpoints: disabled_endpoints, 
						max_cut_off_power: cut_off_power !== null ? cut_off_power : (cut_off_power_consumers || cut_off_power_industrial) ? (cut_off_power_consumers ? Number(cut_off_power_consumers) : 0) + (cut_off_power_industrial ? Number(cut_off_power_industrial) : 0) : null,
						max_number_attracted_avr: number_attracted_avr, 
						max_ka_involved_personnel: ka_involved_personnel, 
						max_ka_involved_special_units: ka_involved_special_units
					})
					let o = 0;
					const title_id = e.title_id.replace('{', '').replace('}', '').split(',');
					const title_others = e.title_others.replace('{', '').replace('}', '').split(',').map(s => s.substr(1, s.length-2));
					e.titleIds = title_id;
					e.title = title_id.map(i => i !== "NULL" ? data1.Result.titles.find(t => t.id == i.trim()).name : title_others[o++]);
					
				})
				this.loadObjects(newUuids, data1)
				
				this.setters.setEvents(data1.Result.eventsZh.sort((a, b) => b.ds - a.ds))
				this.setters.setLoaded(moment())
				this.loadShutoffs(this.data.activeEvents)
			}
		})
		
		const date1 = moment(dates[0]).add(-this.data.maxQuakeMomentOffset, 'h').format('YYYY-MM-DD')
		const date2 = ( dates[1] ? moment(dates[1]) : moment() ).add(1, 'd').format('YYYY-MM-DD')
		//console.log('load quakes', date1, date2)
		const params = {
			d1: date1,
			d2: date2
		}
		fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/earthquake?' + Object.keys(params).map(k => k + '=' + encodeURIComponent(params[k])).join('&'), {
		}).then(res => res.json()).then(data => {
			if (data.success) {
				this.setters.setQuakes(data.quakes.map(e => {return {
					uuid: e.uuid,
					ds: moment(e.ka_event_date),
					inf: JSON.parse(e.inf),
					reg: e.reg,
					d: e.d,
				}}))
			}
		})
		
		fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/fireRegCl').then(res => res.json()).then(data => {
			if (data.success) {
				this.setters.setFireRegCl(data.fireRegCl)
			} else {
				this.setters.setFireRegCl([])
			}
		})
	}
	
	loadPoweroff(reg) {
		fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/poweroff?reg=' + reg).then(res => res.json()).then(data => {
			const _poweroff = {...this.data.poweroff}
			if (!_poweroff[reg] && data.poweroff.length || _poweroff[reg].datasets[0].data.length < data.poweroff.length) {
				_poweroff[reg] = {datasets: [{data: data.poweroff.map(e => {return {x: moment(e.updated), y: Number(e.total)}}) }]}
				this.setters.setPoweroff(_poweroff)
			}
		})
	}
	
	loadPoweroffs(regs) {
		const _poweroff = {...this.data.poweroff}
		Promise.all(regs.map(reg => fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/poweroff?reg=' + reg)))
			.then(ress => Promise.all(ress.map(res => res.json())))
			.then(datas => {
				datas.forEach((data, i) => {
					const reg = regs[i]
					if (!_poweroff[reg] && data.poweroff.length || _poweroff[reg].datasets[0].data.length < data.poweroff.length) {
						_poweroff[reg] = {datasets: [{data: data.poweroff.map(e => {return {x: moment(e.updated), y: Number(e.total)}}) }]}
					}
				})
				this.setters.setPoweroff(_poweroff)
			})
	}
	
	loadShutoffs(uuids) {
		if (uuids.length === 0) return
		const formData = new FormData()
		uuids.forEach(e => formData.append('uuids[]', `${e}`))
		fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/shutoffs', {
			method: 'POST',
			body: formData
		}).then(res => res.json()).then(data => {
			
			// TODO: update if need only
			//if (this.data.shutoffs.length !== data.shutoffs.length)
			// TODO: 2. memory leak - closed dialogs data keeps in memory
			this.setters.setShutoffs([...this.data.shutoffs.filter(e => !uuids.includes(e.uuid)), ...data.shutoffs.map(e => {
				return {
					uuid: e.uuid,
					m:  moment(e.m),
					//na: e.na === 't',
					c:  e.na === 't' || e.c === null ? 0 : Number(e.c),
					ep: e.na === 't' || e.ep === null ? 0 : Number(e.ep),
					o:  e.na === 't' ? 0 : (e.oi === null ? 0 : Number(e.oi)) + (e.oc === null ? 0 : Number(e.oc)),
					ip: e.ip === null ? 0 : Number(e.ip),
					ab: e.ab === null ? 0 : Number(e.ab),
					su: e.su === null ? 0 : Number(e.su),
				}
			})])
			
			// TODO: filter
			this.setters.setOrgs([...this.data.orgs.filter(o => !data.orgs.map(el => el.id).includes(o.id)), ...data.orgs])
			
			// TODO: 2. memory leak - clodes dialogs data keeps in memory
			this.setters.setShutoff_tso([...this.data.shutoff_tso.filter(e => !uuids.includes(e.uuid)), ...data.shutoff_tso.map(e => {
				return {
					uuid: e.uuid,
					m:  moment(e.m),
					c:  e.c === null ? 0 : Number(e.c),
					ep: e.ep === null ? 0 : Number(e.ep),
					o:  (e.oi === null ? 0 : Number(e.oi)) + (e.oc === null ? 0 : Number(e.oc)),
					ip: e.ip === null ? 0 : Number(e.ip),
					ab: e.ab === null ? 0 : Number(e.ab),
					su: e.su === null ? 0 : Number(e.su),
					tso_id: e.tso_id,
					tso_name: e.tso_name,
				}
			})])
			
			// TODO: 2. memory leak - clodes dialogs data keeps in memory
			this.setters.setDef_org([...this.data.def_org.filter(e => !uuids.includes(e.uuid)), ...data.def_org])
			
			/*
			//console.log(
				data.shutoff_tso.map(e => {return {
					id: e.tso_id === null ? null : +e.tso_id,
					name: e.tso_id === null ? e.tso_name : data.tso.find(el => el.ID === e.tso_id).NAME
				}}).reduce((a, e) => {
					if (!a.some(el => el.id === e.id && el.name === e.name)) a.push(e)
					return a
				}, [])
			)
			
			data.shutoffs.filter(e => e._m === 't').forEach(e => {
				
			})
			*/
		})
	}
	
	loadPrevMass(uuid) {
		//console.log('loadPrevMass', uuid)
		fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/prevmass?uuid=' + uuid, {
		}).then(res => res.json()).then(data => {
			if (data.success) {
				//console.log(data)
				this.setters.setPrevMass([...this.data.prevMass, {id: uuid, prevMass: data.mass.map(e => {
					e.ds = moment(e.ds)
					if (hasValue(e.de)) e.de = moment(e.de)
					e.ot = Number(e.oi || 0) + Number(e.oc || 0)
					return e
				})}])
			}
		})
		
	}
	
	loadFire(left, right) {
		let _cache = null
		let _fetch = null
		if (this.data.fireMomentBounds[0].isSame(left)) {
			_cache = [this.data.fireMomentBounds[0], right]
		} else if (this.data.fireMomentBounds[0].isBetween(left, right)) {
			_cache = [this.data.fireMomentBounds[0], right]
			_fetch = [left, this.data.fireMomentBounds[0]]
		} else if (this.data.fireMomentBounds[1].isBetween(left, right)) {
			_cache = [left, this.data.fireMomentBounds[1]]
			_fetch = [this.data.fireMomentBounds[1], right]
		} else {
			_fetch = [left, right]
		}
		if (_fetch) {
			const params = {
				d0: _fetch[0].format('YYYY-MM-DD'),
				t0: _fetch[0].format('HH:mm'),
				d1: _fetch[1].format('YYYY-MM-DD'),
				t1: _fetch[1].format('HH:mm')
			}
			fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/fire2?' + Object.keys(params).map(k => k + '=' + encodeURIComponent(params[k])).join('&'), {
			}).then(res => res.json()).then(data => {
				if (data.success) {
					this.setters.setFires([...data.fire.map(e => {
						e.m = moment(e.m)
						return e
					}), ...this.data.fires.filter(e => e.m.isSameOrAfter(left) && e.m.isBefore(right))]
					.map(e => {
						e.d = Math.min(7, right.diff(e.m, 'h'))
						return e
					}).sort((a, b) => b.d - a.d)
					)
				}
			})
		}
		this.setters.setFireMomentBounds([left, right])
	}
	
	loadWeatherArchive(left, right) {
		const formData = new FormData()
		formData.append('dt0', left.format('YYYY-MM-DD HH:mm'))
		formData.append('dt1', right.format('YYYY-MM-DD HH:mm'))
		fetch('https://xn--h1akdx.xn--80agflthakqd0d1e.xn--p1ai/api/data/weather2', {
			method: 'POST',
			body: formData
		}).then(res => res.json()).then(data => {
			if (data.success) {
				console.log('loader:', data.weather)
				const _w = {}
				data.weather.forEach(w => {
					w.city_id = Number(w.city_id)
					if (!_w[w.city_id]) {
						_w[w.city_id] = {
							lat: Number(w.lat),
							lng: Number(w.lng),
							name: w.name,
							val: []
						}
					}
					_w[w.city_id].val.push({
						date: new Date(w.date.replace(' ', 'T')),
						temp: Number(w.temperature),
						dew:  Number(w.dew_point),
						hum:  Number(w.humidity),
						pres: Number(w.pressure),
						wind: Number(w.wind_speed),
					})
				})
				Object.values(_w).forEach(e => {e.val.sort((a, b) => b.date - a.date)})
				this.setters.setWeatherArchive(_w)
			}
		})
	//this.setters.setWeatherMomentBounds([left, right])
	}
	
}
